import { type Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SignatureRequestSwitch } from '../../../../components/deadline-document-reading/signature-request-switch';
import type { ConsultantDeadlineFormValues } from '../mappers/consultant-deadline-form.mapper';
import type { CompanySignatureAvailability } from './company-signature-availability';

interface CreateSignatureRequestFieldProps {
  control: Control<ConsultantDeadlineFormValues>;
  availability: CompanySignatureAvailability;
}

/**
 * Nuova scadenza: con un solo cliente che non usa Prospero lo switch è spento e disattivato; con
 * più clienti resta attivo e avvisa che la firma va solo a chi ha un account attivo.
 */
export function CreateSignatureRequestField({
  control,
  availability,
}: CreateSignatureRequestFieldProps) {
  const { t } = useTranslation();
  return (
    <Controller
      name="requestClientSignature"
      control={control}
      render={({ field }) => (
        <SignatureRequestSwitch
          checked={field.value}
          onChange={field.onChange}
          helper={t('consultant.deadlines.signature.createHelper', {
            defaultValue:
              "L'azienda firma il documento dalla sua sezione Documenti. Vale anche per i rinnovi.",
          })}
          isUnavailable={availability === 'NONE'}
          note={
            availability === 'SOME'
              ? t('consultant.deadlines.signature.partialNote', {
                  defaultValue: 'La firma verrà chiesta solo alle aziende con un account attivo.',
                })
              : undefined
          }
          testId="consultant-deadline-create-signature"
        />
      )}
    />
  );
}
